import { create } from '@wix/fedops-logger';

const fedopsLogger = create('wix-vod', {/* options */});

export default fedopsLogger;



// WEBPACK FOOTER //
// ./src/widget/utils/fedops-logger.js